import { Directive, Host, Input, OnDestroy } from '@angular/core';
import { NgbNav, NgbNavChangeEvent, NgbNavItem } from '@ng-bootstrap/ng-bootstrap';

import { PendingChangesGuard } from '../guards/pending-changes.guard';
import { ModalService } from '../services/modal.service';

@Directive({
  selector: '[aaTabHasChanges]',
  standalone: false,
})
export class TabHasChangesDirective implements OnDestroy {
  @Input() aaTabHasChanges: boolean;

  private subscriptions = [
    this.tabset.navChange.subscribe(($event: NgbNavChangeEvent) => this.onTabChange($event)),
  ];
  private expectedNextId?: string;

  constructor(
    @Host() private tabset: NgbNav,
    @Host() private tab: NgbNavItem,
    private modalService: ModalService,
  ) {}

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onTabChange({ activeId, nextId, preventDefault }: NgbNavChangeEvent) {
    if (this.tab.id === activeId && this.aaTabHasChanges) {
      // Has the user agreed to navigate away?
      if (nextId === this.expectedNextId) {
        this.expectedNextId = undefined;
        return;
      }

      preventDefault();

      PendingChangesGuard.showModal(this.modalService).subscribe(exit => {
        if (exit) {
          this.expectedNextId = nextId;
          this.tabset.select(nextId);
        }
      });
    }
  }
}
